(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["now-spinning"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initNowSpinning = (section) => {
      if (!section || section.dataset.initialized === 'true') return;

      section.dataset.initialized = 'true';

      const viewport = section.querySelector('[data-now-spinning-viewport]');
      const slides = Array.from(section.querySelectorAll('[data-now-spinning-slide]'));
      const prev = section.querySelector('[data-now-spinning-prev]');
      const next = section.querySelector('[data-now-spinning-next]');
      const dots = Array.from(section.querySelectorAll('[data-now-spinning-dot]'));

      if (!viewport || slides.length === 0) return;

      let activeIndex = 0;
      let rafId;

      const setActiveDot = (index) => {
        dots.forEach((dot, dotIndex) => {
          const active = dotIndex === index;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-current', active ? 'true' : 'false');
        });
      };

      const setViewportHeight = (index) => {
        const slide = slides[index];
        if (!slide) return;

        requestAnimationFrame(() => {
          const height = slide.offsetHeight;
          if (height > 0) viewport.style.height = `${height}px`;
        });
      };

      const activate = (index) => {
        activeIndex = Math.max(0, Math.min(index, slides.length - 1));
        setActiveDot(activeIndex);
        setViewportHeight(activeIndex);
      };

      const goTo = (index, behavior = 'smooth') => {
        const target = slides[index];
        if (!target) return;

        activate(index);

        viewport.scrollTo({
          left: target.offsetLeft,
          behavior
        });
      };

      const syncFromScroll = () => {
        const width = viewport.clientWidth || 1;
        const index = Math.round(viewport.scrollLeft / width);

        if (index !== activeIndex) {
          activate(index);
        }
      };

      prev?.addEventListener('click', () => {
        const index = activeIndex <= 0 ? slides.length - 1 : activeIndex - 1;
        goTo(index);
      });

      next?.addEventListener('click', () => {
        const index = activeIndex >= slides.length - 1 ? 0 : activeIndex + 1;
        goTo(index);
      });

      dots.forEach((dot, index) => {
        dot.addEventListener('click', () => goTo(index));
      });

      viewport.addEventListener('scroll', () => {
        cancelAnimationFrame(rafId);
        rafId = requestAnimationFrame(syncFromScroll);
      }, { passive: true });

      section.querySelectorAll('img').forEach((image) => {
        if (image.complete) return;

        image.addEventListener(
          'load',
          () => setViewportHeight(activeIndex),
          { once: true }
        );
      });

      window.addEventListener('resize', () => {
        setViewportHeight(activeIndex);
      });

      section.addEventListener('shopify:block:select', (event) => {
        const selectedSlide = event.target.closest('[data-now-spinning-slide]');
        const index = slides.indexOf(selectedSlide);

        if (index >= 0) {
          goTo(index, 'auto');
        }
      });

      activate(0);
    };

    const initAll = (root = document) => {
      root.querySelectorAll('[data-now-spinning]').forEach(initNowSpinning);
    };

    initAll();

    document.addEventListener('shopify:section:load', (event) => {
      initAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
